export default {
  setShopListGalleryList(state, payload) {
    const { title, pics } = payload
    state.shopDetailGalleryList.title = title
    state.shopDetailGalleryList.pics = pics
  },
  updateShopDetail(state, payload) {
    state.shopBaseDetail = Object.assign(state.shopBaseDetail, payload)
  },
  updateCurrentShopDetail(state, payload) {
    state.currentShopBaseDetail = Object.values(payload)[0]
  },

  updatePaymentCalculator(state, payload) {
    state.paymentCalculator = payload
  },

  updateCurrencyPrecision(state, payload) {
    state.currencyPrecision = payload
  },

  updateBizoppDetail(state, payload) {
    state.bizoppDetail = Object.assign(state.bizoppDetail, payload)
  },
  updateCurrentBizoppDetail(state, payload) {
    state.currentBizoppDetail = Object.values(payload)[0]
  },
  updateBizoppType(state, payload) {
    state.type = payload
  },
  updateBizoppBillAccount(state, payload) {
    state.currentBizoppBillAccount = payload
  },
  updateAllConfig(state, payload) {
    state.allConfig = Object.assign(state.allConfig, payload)
  },
  updateCurrentAllConfig(state, payload) {
    state.currentAllConfig = Object.values(payload)[0]
  },
  updateContractorDetail(state, payload) {
    state.contractorDetail = Object.assign(state.contractorDetail, payload)
  },
  updateCurrentContractorDetail(state, payload) {
    state.currentContractorDetail = Object.values(payload)[0]
  },
  updateCurrentSelected(state, payload) {
    state.currentSelected = payload
  },
  toggleShowDatePick(state, payload) {
    state.showDatePick = payload
  },
  toggleShowPicker(state, payload) {
    state.showPicker = payload
  },
  toggleBackoutApply(state, payload) {
    state.backoutApply = payload
  },
  clearAllCurrentInfo(state) {
    state.currentAllConfig = {}
    state.currentContractorDetail = {}
    state.currentShopBaseDetail = {}
    state.currentBizoppDetail = {}
  },
  clearCache(state, payload) {
    const obj = {}
    const { shopId } = payload
    obj[shopId] = {}
    state.contractorDetail = Object.assign(state.contractorDetail, obj)
    state.shopBaseDetail = Object.assign(state.shopBaseDetail, obj)
    state.allConfig = Object.assign(state.allConfig, obj)
    state.bizoppDetail = Object.assign(state.bizoppDetail, obj)
  },
  updateSaleData(state, payload) {
    state.saleData = payload
  },
  updateItemOptions(state, payload) {
    state.itemOptions = payload
  },
  updateItemOptionTotal(state, payload) {
    state.itemOptionTotal = payload
  },
  updatePreSignupList(state, payload) {
    state.preSignupList = payload
  },
  updateAllSelectItems(state, payload) {
    state.allSelectItems = payload
  },
  updateConfirmSelectItems(state, payload) {
    state.confirmSelectItems = payload
  },
  updateSpecialItemList(state, payload) {
    state.specialItemList = payload
  },
  updateConfirmStatus(state, payload) {
    state.confirmStatus = payload
  },
}
